import { buildProductBadge } from './utils';
import QuickShopClass from '../../components/product-quickshop/product-quickshop.js';
import { hideCartSideDraw } from '../../sections/cart-drawer.js';

export default () => ({
  useMiniCards: true,
  visible: false,
  buildProductBadge,
  slider: null,
  buttonText: 'Learn More',
  themeColor: '#602379',
  themeColorForeground: '#5a5959',
  productCardBackground: '#f4f0f6',

  // GTM Event tracking helper
  fireGTMEvent(panelState, source = 'Cart Drawer') {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cross_sell_cart_slider_state',
        feature: source === 'Cart Drawer' ? 'Cross-Sell Cart Drawer' : 'Cross-Sell Cart Page',
        cart_slider_state: panelState,
      });
    }
  },

  init() {
    this.useMiniCards = this.$el.hasAttribute('data-use-mini-cards');
    this.buttonText = this.$el.dataset.buttonText;
    this.themeColor = getComputedStyle(this.$el).getPropertyValue('--theme-color').trim();
    this.themeColorForeground = getComputedStyle(this.$el).getPropertyValue('--theme-color-foreground').trim();
    this.productCardBackground = getComputedStyle(this.$el).getPropertyValue('--product-card-background').trim();

    // Initial fetch of cart data
    // setTimeout(() => {
    // }, 1000);
    this.fetchCartAndUpdate();

    // Use jQuery event system instead of native DOM events
    $(document).on('cart.requestComplete', () => {
      // console.log('Cart updated');
      this.fetchCartAndUpdate();
    });

    // watch for cart drawer open/close
    document.addEventListener('cartDrawer:open', () => {
      if (this.visible) {
        this.fireGTMEvent('Cart Slider Show');
      }
    });

    // Watch for expanded state changes
    this.$watch('visible', (value, oldValue) => {
      if (value !== oldValue && oldValue !== undefined) {
        if (value) {
          if (this.$el.closest('.cart-drawer-section-wrapper.active')) {
            this.fireGTMEvent('Cart Slider Show');
          } else if (this.$el.closest('.cart-section')) {
            this.fireGTMEvent('Cart Slider Show', 'Cart Page');
          }
        } else {
          if (this.$el.closest('.cart-drawer-section-wrapper.active')) {
            this.fireGTMEvent('Cart Slider Off');
          } else if (this.$el.closest('.cart-section')) {
            this.fireGTMEvent('Cart Slider Off', 'Cart Page');
          }
        }
      }
    });
  },

  async fetchCartAndUpdate() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (cart?.items?.length > 0) {
        const metafieldsData = JSON.parse(
          document.getElementById('cart-metafields-data')?.textContent || '{"items":[]}'
        );

        const excludeMap = new Map();
        metafieldsData.items.forEach(item => {
          excludeMap.set(item.product_id, item.exclude_cart_slider);
        });

        const items = cart.items
        .filter((item) => {
          const isExcluded = excludeMap.get(item.product_id) === true;
          // if (isExcluded) {
          //   console.log(`Excluding product ${item.product_id} from cart recommendations`);
          // }
          return !isExcluded;
        })
        .map((item) => ({
          product_id: item.product_id,
        }));

        // Update store with current cart items
        Alpine.store('xsell')
          .cart.fetchAllRecommendations(items)
          .then(() => {
            if (Alpine.store('xsell').cart.crossSellProducts.length) {
              this.visible = true;
              if (this.slider) {
                this.slider.update();
              }
            } else {
              this.visible = false;
            }
          });
      } else {
        this.visible = false;
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
      this.visible = false;
    }
  },

  initSwiper() {
    this.$nextTick(() => {
      const slider = new Swiper(this.$refs.productsSlider, {
        slidesPerView: this.useMiniCards ? 1 : 1.5,
        spaceBetween: 16,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.cart-xsell-slider .swiper-button-next',
          prevEl: '.cart-xsell-slider .swiper-button-prev',
        },
      });
      // slider.init();
      this.slider = slider;
    });
  },

  openQuickshop(product) {
    const quickshop = QuickShopClass.getInstance();

    const quickshopConfig = {
      headerText: this.buttonText,
      themeClass: 'quickshop--cart-xsell-theme',
      themeColor: {
        theme: this.themeColor,
        foreground: this.themeColorForeground,
        background: this.productCardBackground,
      },
      source: this.$el.closest('.cart-section') ? 'cross-sell-cart-page' : 'cross-sell-cart-drawer',
    };


    if (this.$el.closest('.cart-drawer-section-wrapper.active')) {
      // console.log('Hiding cart drawer');
      hideCartSideDraw();
    }

    try {
      quickshop.addToQuickshop(product.handle, false, null, quickshopConfig);
    } catch (error) {
      console.error('Error in addToQuickshop:', error);
    }
  },

  get products() {
    return Alpine.store('xsell').cart.crossSellProducts;
  },
});
